import { VantivCardTypes } from "../../types/vantiv";

export const getHumanReadableCardType = (vantivCardType: keyof typeof VantivCardTypes) => {
  switch (vantivCardType) {
    case "VI":
      return "VISA";
    case "MC":
      return "MASTER CARD";
    case "AX":
      return "AMEX";
    case "DC":
      return "DINER";
    case "DI":
      return "DISCOVER";
    case "JC":
      return "JCB";
    default:
      return vantivCardType;
  }
};

export const isAvsReady = (paymentSource: any) => {
  const { street_address, city, state, zip } = paymentSource;
  return Boolean(street_address && city && state && zip);
};
